import { useEffect, useState } from 'react';
import Tabela from '../../Misc/Tabela/Tabela';
import { Button } from 'react-bootstrap';
import { usePARevisao } from './pa_revisao_context';
import PARevisaoDirecionamento from './components/pa_revisao_modal_direcionamento';
import PARevisaoGrade from './components/pa_revisao_modal_grade';
import styles from './pa_revisao.module.scss'
import PARevisaoModalConfirmacaoSQ from './components/pa_revisao_modal_confirmacao_sq';
import PARevisaoModalProcessamento from './components/pa_revisao_modal_processamento';
import FiltroRevisao from './components/pa_revisao_filtro';
import PARevisaoModalInfo from './components/pa_revisao_modal_informacoes';
import PARevisaoModalLocalizacao from './components/pa_revisao_localizacao';
import PARevisaoModalDespriorizacao from './components/pa_revisao_modal_despriorizacao';
import PARevisaoModalCancelamento from './components/pa_revisao_modal_cancelar_analise';
import WarningTriangle from '../ChecklistFollowUp/components/priorizacao/warning_triangle';

const PARevisaoMain = () => {
  const { listaRevisaoFiltrada, iniciarRevisao, modalRevisao, modalDirecionamento, modalConfirmacaoSQ, modalProcessamento, modalInfo, abrirModalInformacoes, showModalInformacoes, showModalLocalizacao, visaoAnalista, showModalDespriorizacao, setModalCancelamento } = usePARevisao();

  const [listaRevisaoFiltradaOperadoras, setListaRevisaoFiltradaOperadoras] = useState([]);
  useEffect(() => {
    const x = listaRevisaoFiltrada.sort((a, b) => a.row_index_operadoras - b.row_index_operadoras)
    setListaRevisaoFiltradaOperadoras([...x]);
  }, [listaRevisaoFiltrada]);

  const revisaoColumnsOperacao = [
    {
      cell: row => {
        return (
          <WarningTriangle
            color={row.em_revisao ? '01D10C' : row.cor_prioridade}
            prioridade={row.prioridade}
            btn={
              <Button
                style={{ fontWeight: '500' }}
                variant={row.nf_segunda_qualidade || row.produto_de_couro ? 'warning' : 'primary'}
                onClick={() => iniciarRevisao(row)}
                disabled={
                  row.em_revisao
                  // || (row.prioridade === 0 && row.row_index_operadoras > 10)
                }
              >
                {row.nf_segunda_qualidade || row.produto_de_couro ? 'Rev. 100%' : 'Revisão'}
              </Button>
            }
          />
        )
      }, width: '180px'
    },
    { name: 'Index', selector: row => row.row_index_operadoras },
    {
      name: 'Localizado Revisão?', selector: row => {
        return row.localizacao_na_revisao ?
          <div className={styles.loc_label_true}>Sim</div> :
          <div className={styles.loc_label_false}>Não</div>
      }, width: '160px'
    },
    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Serie NF', selector: row => row.serie_nf },
    { name: 'Origem', selector: row => row.origem },
    { name: 'Filial Revisão', selector: row => row.filial_revisao },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Desc. Produto', selector: row => row.descricao_produto },
    { name: 'Cor', selector: row => row.cor_produto },
    { name: 'Desc. Cor', selector: row => row.descricao_cor },
    { name: 'Qtde.', selector: row => row.qtde_entrada },
    { name: 'Ordem Produção', selector: row => row.ordem_producao },
    { name: 'Coleção', selector: row => row.colecao },
    { name: 'Linha', selector: row => row.linha },
    { name: 'Preço', selector: row => row.preco },
    { name: 'Data Entrada Revisão', selector: row => row.data_entrada_revisao_br }
  ];

  const revisaoColumnsAnalise = [
    {
      cell: (row, index) => {
        return (
          <Button
            style={{ fontWeight: '500' }}
            variant={'primary'}
            onClick={() => abrirModalInformacoes(row)}
          >
            Informações
          </Button>
        )
      }, width: '160px'
    },
    {
      name: 'Localizado Revisão?', selector: row => {
        return row.localizacao_na_revisao ?
          <div className={styles.loc_label_true}>Sim</div> :
          <div className={styles.loc_label_false}>Não</div>
      }, width: '160px'
    },
    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Serie NF', selector: row => row.serie_nf },
    { name: 'Origem', selector: row => row.origem },
    { name: 'Filial Revisão', selector: row => row.filial_revisao },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Desc. Produto', selector: row => row.descricao_produto },
    { name: 'Cor', selector: row => row.cor_produto },
    { name: 'Desc. Cor', selector: row => row.descricao_cor },
    { name: 'Qtde.', selector: row => row.qtde_entrada },
    { name: 'Ordem Produção', selector: row => row.ordem_producao },
    { name: 'Coleção', selector: row => row.colecao },
    { name: 'Linha', selector: row => row.linha },
    { name: 'Preço', selector: row => row.preco },
    { name: 'Data Entrada Revisão', selector: row => row.data_entrada_revisao_br }
  ];

  return (
    <section className={styles.revisao_body_wrapper}>
      <section className={styles.flex_title}>
        <h4 className={styles.title}>Revisão PA</h4>
      </section>
      <section className={styles.header_section} style={{ marginBottom: '20px !important' }}>
        <div className={styles.adm_btn_wrapper}>
          <FiltroRevisao />
        </div>
      </section>
      <section style={{ margin: '0px 20px 20px' }}>
        <Tabela
          columns={visaoAnalista ? revisaoColumnsAnalise : revisaoColumnsOperacao}
          data={visaoAnalista ? listaRevisaoFiltrada : listaRevisaoFiltradaOperadoras}
          pending={false}
          pagination={true}
          paginationPerPage={20}
          highlightOnHover={true}
        />
      </section>

      {modalInfo && <PARevisaoModalInfo />}
      {modalRevisao && <PARevisaoGrade />}
      {modalDirecionamento && <PARevisaoDirecionamento />}
      {modalConfirmacaoSQ && <PARevisaoModalConfirmacaoSQ />}
      {modalProcessamento && <PARevisaoModalProcessamento />}
      {showModalInformacoes && <PARevisaoModalInfo />}
      {showModalLocalizacao && <PARevisaoModalLocalizacao />}
      {showModalDespriorizacao && <PARevisaoModalDespriorizacao />}
      {setModalCancelamento && <PARevisaoModalCancelamento />}
    </section>
  )
}

export default PARevisaoMain;
